  if (typeof Ajaxinate !== 'undefined') {
    const endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      loadingText: 'Loading...',
      method: "scroll",
      callback: function() {
      }
    });
  }